module.exports = __webpack_public_path__ + "img/19.5c156034.jpg";